import { MasterScheduleMaterialsStateTypes, MasterScheduleMaterialsActionTypes } from "./MasterScheduleMaterials.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MasterScheduleMaterialsStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MasterScheduleMaterialsReducer = (
  state: MasterScheduleMaterialsStateTypes = INITIAL_STATE,
  action: any
): MasterScheduleMaterialsStateTypes => {
  switch (action.type) {
    case MasterScheduleMaterialsActionTypes.FETCH_ALL_MASTER_SCHEDULE_MATERIALS:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MasterScheduleMaterialsActionTypes.FETCH_ALL_MASTER_SCHEDULE_MATERIALS_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MasterScheduleMaterialsActionTypes.FETCH_ALL_MASTER_SCHEDULE_MATERIALS_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MasterScheduleMaterialsActionTypes.FETCH_ALL_MASTER_SCHEDULE_MATERIALS_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MasterScheduleMaterialsActionTypes.FETCH_ONE_MASTER_SCHEDULE_MATERIALS:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MasterScheduleMaterialsActionTypes.FETCH_ONE_MASTER_SCHEDULE_MATERIALS_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MasterScheduleMaterialsActionTypes.FETCH_ONE_MASTER_SCHEDULE_MATERIALS_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MasterScheduleMaterialsActionTypes.FETCH_ONE_MASTER_SCHEDULE_MATERIALS_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MasterScheduleMaterialsReducer;
